import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import { NormalRange } from "./NormalRange"
import styles from "./Ranges.module.scss"
import { SleepHours } from "./SleepHours"
import { UrgentLow } from "./UrgentLow"
import { PageTemplate } from "src/components"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"

import {
  useDebouncedUpdater,
  useUpdateFollow,
} from "src/hooks"

const polyglotPrefix = "pages.settings.ranges."

export function Ranges() {
  const polyglot = usePolyglot()
  const {
    currentUserId,
    currentFollow,
  } = useFollowedUsers()

  const followId = currentFollow.id
  const followUpdatedAt = currentFollow.updated_at

  // TODO catch error and show toast
  const updateFollow = useUpdateFollow()
  const debouncedUpdateFollow = useDebouncedUpdater({ updater: updateFollow })

  const debouncedUpdateFollowWithId = useCallback(
    (follow: Partial<Follow>) => debouncedUpdateFollow({
      id: followId,
      ...follow,
    }),
    [
      debouncedUpdateFollow,
      followId,
    ],
  )

  return (
    <PageTemplate
      user="follow"
      title={polyglot.t("components.page_header.pages.ranges")}
      backRoutePath={currentFollow.is_self ? "/settings" : "/settings/$accountId"}
      backRouteParams={currentFollow.is_self ? {} : { accountId: currentUserId }}
    >
      <div className={styles.container}>
        <div className={styles.description}>
          {polyglot.t(`${polyglotPrefix}description`)}
        </div>
        <NormalRange
          updatedAt={followUpdatedAt}
          updateFollow={debouncedUpdateFollowWithId}
        />
        <UrgentLow
          updatedAt={followUpdatedAt}
          updateFollow={debouncedUpdateFollowWithId}
        />
        <SleepHours
          updatedAt={followUpdatedAt}
          updateFollow={debouncedUpdateFollowWithId}
        />
      </div>
    </PageTemplate>
  )
}
